import styled from "styled-components";

export const AboutUsCardStyles = styled.div`
padding: 3.75rem;
position: relative;
color: #fff;


& div {
	position: relative;
	z-index: 2;
}

& p{
	font-size: 14px;
	margin-top: 3.125rem;
}

& span{
	position: absolute;
	display: block;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

@media(max-width:1250px){
	padding: 2rem;
}
`